// extracted by mini-css-extract-plugin
export default {"qr_compact":"QrBlock_qr_compact__MSI4H","qr_box":"QrBlock_qr_box__bNSTJ","qr_label":"QrBlock_qr_label__XhFQr","qr_title":"QrBlock_qr_title__SApnL","qr_text":"QrBlock_qr_text__TcDvJ"};